export default {
  data() {
    return {
      form: {
        mobileCountry: '+62',
        mobile: '',
        verificationCode: '',
      },
      mobilePrefixList: [
        {
          text: '+61',
          value: '+61',
        },
        {
          text: '+62',
          value: '+62',
        },
        {
          text: '+65',
          value: '+65',
        },
        {
          text: '+81',
          value: '+81',
        },
        {
          text: '+82',
          value: '+82',
        },
        {
          text: '+852',
          value: '+852',
        },
        {
          text: '+86',
          value: '+86',
        },
        {
          text: '+886',
          value: '+886',
        },
      ],
      sendCountdown: null,
      sendInterval: null,
      selectorVisible: false,
    }
  },
  computed: {
    sendButtonText() {
      if (this.sendCountdown === null) {
        return this.$t('send')
      }
      if (this.sendCountdown <= 0) {
        return this.$t('resend')
      }
      return `${this.sendCountdown}s`
    },
  },
  methods: {
    showSelector() {
      this.selectorVisible = true
    },
    onSelectorChoose({ text }) {
      this.form.mobileCountry = text
    },
    startCountdown() {
      this.stopCountdown()
      this.sendCountdown = 60
      this.sendInterval = setInterval(() => {
        this.sendCountdown -= 1
        if (this.sendCountdown === 0) {
          clearInterval(this.sendInterval)
          this.sendInterval = null
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.sendInterval) {
        clearInterval(this.sendInterval)
        this.sendInterval = null
      }
      this.sendCountdown = 0
    },
    async checkMobile() {
      try {
        const uri = `/auth/check-mobile?phone=${this.form.mobileCountry}${this.form.mobile}`
        this.$toast.loading('loading...')
        const response = await this.$http.get(uri)
        if (response.data.code !== 'SUCCESS') {
          this.$toast.failed(this.$t(response.data.code))
          return false
        }
        return true
      } catch (e) {
        console.error(e)
        return false
      } finally {
        this.$toast.hide()
      }
    },
    async getVerifyCode(scope) {
      const checkResult = await this.checkMobile()
      if (!checkResult) {
        return
      }
      this.error = null
      this.startCountdown()
      const path = {
        signup: '/auth/register-code',
        additional: '/auth/binding-code',
      }[scope]
      const url = `${path}?phone=${this.form.mobileCountry}${this.form.mobile}`
      try {
        this.$toast.loading('loading...')
        const res = await this.$http.post(url)
        this.$toast.succeed(this.$t('verificationCodeSent'))
        this.form.verificationCode = res.data.extra
      } catch (error) {
        console.error(error)
        this.stopCountdown()
      } finally {
        this.$toast.hide()
      }
    },
  },
}
